// Material Icons 字体加载器
import MaterialIconsWoff2 from '@/assets/fonts/MaterialIcons-Regular.woff2'

class FontLoader {
  constructor() {
    this.fontLoaded = false
    this.fontPromise = null
  }

  // 动态加载Material Icons字体
  async loadMaterialIcons() {
    if (this.fontLoaded) {
      return Promise.resolve()
    }

    if (this.fontPromise) {
      return this.fontPromise
    }

    this.fontPromise = new Promise((resolve, reject) => {
      try {
        // 创建字体样式
        const fontFace = new FontFace(
          'Material Icons',
          `url(${MaterialIconsWoff2})`,
          {
            style: 'normal',
            weight: '400',
            display: 'block'
          }
        )

        // 加载字体
        fontFace.load().then((loadedFont) => {
          // 添加到document.fonts
          document.fonts.add(loadedFont)
          this.fontLoaded = true
          
          // 显示所有material-icons元素
          this.showMaterialIcons()
          
          resolve()
        }).catch((error) => {
          console.error('字体加载失败:', error)
          // 即使失败也要显示图标（使用fallback）
          this.showMaterialIcons()
          resolve()
        })
      } catch (error) {
        console.error('字体加载器初始化失败:', error)
        // 降级方案：直接显示图标
        this.showMaterialIcons()
        resolve()
      }
    })

    return this.fontPromise
  }

  // 显示所有Material Icons元素
  showMaterialIcons() {
    const materialIcons = document.querySelectorAll('.material-icons')
    materialIcons.forEach(el => {
      el.classList.add('font-loaded')
      el.style.visibility = 'visible'
    })
  }

  // 检查字体是否已加载
  isFontLoaded() {
    return this.fontLoaded
  }
}

// 创建单例实例
const fontLoader = new FontLoader()

export default fontLoader 